import { useTranslation } from "react-i18next";
import css from "./index.module.css";
import ButtonComponent from "../../cubeComponent/form/ButtonComponent";
import { getImageUrl } from "@Utils";

function SubscriptionWarning({ message, description, showUpgradeButton, showFooterMessage }) {
  const { t } = useTranslation();
  return (
    <>
      <div className={css.root}>
        <img className="" src={`${getImageUrl()}/logoAndText.png`} />
        <div className={css.body}>
          <div className={css.imageWrapper}>
            <img className={css.image} src={`${getImageUrl()}/subscriptionWarning.svg`} />
            <div className={css.welcomeText}>
              <span className={css.welcomeHeader}>{message}</span>
              <span className={css.welcomeDescription}>{description}</span>
            </div>
          </div>
          {showUpgradeButton && (
            <div className={css.upgradeButton}>
              <ButtonComponent>{t("Upgrade")}</ButtonComponent>
            </div>
          )}
        </div>
        {showFooterMessage && (
          <div className={css.footer}>
            {t(
              "Need support with increasing/decreasing your seats or have any questions related to pricing or billing? Raise a support ticket here.",
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default SubscriptionWarning;
